import React, { Component } from 'react';
import { connect } from 'react-redux';

import { LoadingBar, StatTable } from 'components/Commons';
import cm from 'helpers/commons';

class StoreStatsResult extends Component {
  render() {
    const { storeStats } = this.props,
      { type } = this.props.resultFn;

    let tabledata;
    if (storeStats) {
      if (storeStats.data) {
        const { stat } = storeStats.data;

        if (stat && stat.length > 0) {
          tabledata = stat.map((item) => {
            const { store } = item;
            const depth1 = store.map((item1) => {
              let obj1 = {
                row: [
                  {
                    content: item1.sdate,
                    textAlign: 'left'
                  },
                  {
                    content: item1.storename,
                    textAlign: 'left'
                  },
                  {
                    content: cm.numberComma(item1.salesprice),
                    textAlign: 'right'
                  },
                  {
                    content: cm.numberComma(item1.companyprice),
                    textAlign: 'right'
                  },
                  {
                    content: cm.numberComma(item1.mcount),
                    textAlign: 'right'
                  },
                  {
                    content: cm.convertMinusNumber(item1.cancelprice),
                    textAlign: 'right',
                    fontColor: '#e20b44'
                  }
                ]
              };
              return obj1;
            });

            let obj = {
              header: [{ content: item.sdate, colSpan: 6 }],
              body: depth1
            };
            return obj;
          });
        } else {
          tabledata = '제휴식당 통계 목록이 없습니다.';
        }
      } else if (storeStats.response) {
        tabledata = storeStats.response.data.message;
      }
    } else {
      tabledata = '제휴식당 통계 목록이 없습니다.';
    }

    let loading = '';
    if (!tabledata) {
      loading = <LoadingBar />;
    }
    return (
      <div className="store-stat-result table-container">
        {loading}

        <div className="table-box">
          <StatTable
            colWidth={[220, 550, 140, 140, 140, 140]}
            header={[
              { content: '날짜', textAlign: 'left' },
              { content: '제휴식당', textAlign: 'left' },
              { content: '총 회사식대', textAlign: 'right' },
              { content: '총 정산금액', textAlign: 'right' },
              { content: '식사횟수', textAlign: 'right' },
              { content: '취소식대', textAlign: 'right' }
            ]}
            data={tabledata}
          />
        </div>
      </div>
    );
  }
}

StoreStatsResult = connect((state) => ({
  storeStats: state.usage.storeStats
}))(StoreStatsResult);

export default StoreStatsResult;
